import { render, staticRenderFns } from "./NewPaymentMethodForm.vue?vue&type=template&id=0c10e685&scoped=true&"
import script from "./NewPaymentMethodForm.vue?vue&type=script&lang=js&"
export * from "./NewPaymentMethodForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c10e685",
  null
  
)

export default component.exports